import { Outlet, useLocation } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import styles from './Layout.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { fetchLayoutData } from 'features/layout/layoutSlice';
import { useEffect } from 'react';
import { fetchRegions } from 'features/region/regionSlice';


const Layout = () => {
    const location = useLocation();
    const noBgRoutes = ['/browser-compatibility'];
    const showBackground = !noBgRoutes.includes(location.pathname);
    const dispatch = useDispatch<AppDispatch>();
    const region = useSelector((state: RootState) => state.region.region);

    useEffect(() => {
        if (region) {
            dispatch(fetchLayoutData(region));
        }
    }, [dispatch, region]);

    useEffect(() => {
        dispatch(fetchRegions());
    }, [dispatch]);

    return (
        <>
            <div className={`container-fluid min-vh-100 d-flex flex-column ${styles.noPaddingContainer}`}>
                <div className={showBackground ? styles.contentWrapper : styles.noBackgroundImage}>
                    <Header />
                    <main className={`flex-grow-1 ${styles.centerContent}`}>
                        <div className="row">
                            <Outlet />
                        </div>
                    </main>
                </div>
                <Footer />
            </div>
            {/* To avoid flickering issue in material-icons */}
            <div className={`material-icons ${styles.hiddenElement}`}>.</div>
        </>
    );
};

export default Layout;
